import $ from 'jquery';
import './notify-me';
import heartProduct from "modules/heart-product";
import setUpBisAndSo from "./bis-and-so";
import setupStyliticsToggle from "./stylitics-toggle";
import { addToBag, addBuyNowProduct } from './add-to-bag';
import 'vendor/jquery.lazy.youtube.min';
import { preloadColorMarkup } from 'modules/preload-markup';
import { addToBagWithData } from "modules/add-to-bag";
import { revieveTryOn, revieveAddToBag } from '../../modules/revieve-try-on';
import { revieveMakeupAdvisor } from "../../modules/revieve-makeup-advisor";
import { renderPdpSocialProof } from 'modules/social-proof';
import { logEngagementWithDetails } from "../../modules/global/log-engagement";
import StickyAddToBag from './sticky-add-to-bag';

var horizontalScrollMenu = require('./horizontal-scroll-menu');
var chatWindowQa = require('./chat-window-qa');
var colorDropdown = require('./color-dropdown');
window.productHearts = {};

window.setupBisAndSo = setUpBisAndSo;
window.setupStyliticsToggle = setupStyliticsToggle;
window.addToBagWithData = (data, callbacks, addToBagUrl) => {
    if (data.fromZelig) {
        callbacks = {};
        callbacks.success = () => {
            insertPageTrackForMobileWithData({
                addToCartFlag: true,
                productCode: data.code,
                isZeligAddToBag: true
            });
        };
    }
    addToBagWithData(data, callbacks, addToBagUrl);
};

function getSelectedSize() {
    let size = '';
    if ($('#pdp-size-options').length) {
        const $checkedSizeOption = $('#pdp-size-options input:checked');
        if($checkedSizeOption.length) {
            size = $checkedSizeOption.val();
        }
    } else if ($('#size-products').length) {
        size = $('#size-products option:selected').val();
    } else {
        const selectedSize = $('select#size');
        if (selectedSize.is(':visible')) {
            size = selectedSize.val();
        }
    }
    return size;
}

function initHorizontalScrollMenu() {
    horizontalScrollMenu();
}
function addToFavorites(pcode, favorited, callBack) {
    let selectedSize = getSelectedSize();
    var isGuest = $('#myFavLimitPopup').data('isGuest');
    var productSize = $('#tr_top_heart_mhp_count').data('count');
    if (isGuest) {
        $('#guestLimitPop, #fav-create-link').attr('href', '/r/mobile/LoginPage.jsp?favcode=' + pcode +'&ref=' + encodeURIComponent(window.location.pathname + window.location.search));
        $.modal({triggerOpen:true, open: 'guestLimitPop'});
        return;
    } else if (!isGuest && productSize > 1999) {
        $.modal({triggerOpen:true, open: 'userLimitPop'});
        return;
    }
    if(favorited) {
        heartProduct.submitHeart('product', pcode, 'add', selectedSize, null, callBack);
        window.productHearts[pcode] = true;
    } else {
        heartProduct.submitHeart('product', pcode, 'remove', selectedSize, null, callBack);
        window.productHearts[pcode] = false;
    }
}

window.addFavEvent = function addFavEvent(el){
    if(!el) return;
    el.addEventListener('favorite', function (e) {
        var pcode = $(this).data('code');
        var favorited = e.detail.favorited;
        var callBack = e.detail.callback;
        addToFavorites(pcode, favorited, callBack);
    });
}

let sizeNotSelectedBeforeAddingToBag = false;
$('body').on('change','#size',function(){
    if(sizeNotSelectedBeforeAddingToBag){
        const addToBagButton = $('#add-to-bag-btn:visible');
        if (addToBagButton.length > 0) {
            window.addToBag(addToBagButton);
        }
        sizeNotSelectedBeforeAddingToBag = false;
    }
});

window.bindSizeGuideEvent = function() {
    $('.js-size-guide-modal').on('click', function() {
        if ($(this).data('fitPredictorCode') && $(this).data('showDynamicSizeGuide')) {
            ssp('start', 'sizeguide');
            ssp('track', 'triggerSizeGuide', {
                productId: $(this).data('fitPredictorCode'),
                origin: 'sizeguide-cta'
            });
        }

        $.modal({
            url: `${$(this).data('url')}`,
            triggerOpen: true,
            type: 'full',
            triggerElement: $(this),
        })
    });

    $('.view_size_guide').click(function () {
        logEngagementWithDetails(window.location.href, 'PDP Size Click', 'Click', 'View Size Guide');
    });
};

document.addEventListener("DOMContentLoaded", function() {
    // const SHOW_IMAGES = rcProps.yotpo.showReviewImages;
    let srProcessed = false;
    let fullProcessed = false;

    const observer = new MutationObserver(function(mutationsList, observer) {
        const widgetElement = document.querySelector('.yotpo-widget-instance');
        if (!widgetElement) return;

        // check if product has yotpo reviews or 0. Hide if 0.
        if (!srProcessed) {
            const $srReviewText = $('.yotpo-sr-bottom-line-text.yotpo-sr-bottom-line-text--right-panel');
            if ($srReviewText.length) {
                srProcessed = true;
                const reviewCount = parseInt($srReviewText.text().match(/\d+/)?.[0] || '0', 10);
                if (reviewCount === 0) {
                    $('.yotpo-widget-instance').has('.yotpo-sr-bottom-line-text--right-panel').hide();
                }
            }
        }

        if (fullProcessed) return;

        const fullText = document.querySelector('.yotpo-bottom-line-basic-text');
        if (!fullText) return;

        fullProcessed = true;

        // extract only numbers from fullText
        if (document.querySelector('.yotpo-widget-instance.ab929')) {
            const fullTextReviewNum = fullText?.textContent.match(/[\d,]+/)?.[0] || '';
            const productReviewAccordionText = document.querySelector('#product-reviews .accordion__label-text');
            productReviewAccordionText.textContent = `${productReviewAccordionText.textContent} (${fullTextReviewNum})`
            fullText.textContent = `${fullTextReviewNum} Review${fullTextReviewNum !== '1' ? 's' : ''}`;
        }

        const widgetElementDetailsMarkup = document.querySelector('#detailsMarkup .yotpo-widget-instance');
        if(widgetElementDetailsMarkup) {
            widgetElementDetailsMarkup.style.display = 'none';
        }

        if ($('.js-scroll-menu').length) {
            initHorizontalScrollMenu();
        }
        observer.disconnect();
    });

    // Start observing the document body for added nodes
    observer.observe(document.body, { childList: true, subtree: true });
});

if (rcProps.abtests.personalizedPla) {
    window.stickyATB = new StickyAddToBag();

    $(document).on('click', '.js-personalized-pla-tag', function () {
        const tag = $(this).data('personalized-pla-tag');
        if (tag && tag.toString().trim() !== '') {
            const params = new URLSearchParams(window.location.search);
            params.set("selectedPlaTag", tag); // safely adds/updates
            window.history.pushState({}, '', `${window.location.pathname}?${params.toString()}`);
        }
    });

    $(document).on('click', '.js-personalized-pla-more', async () => {
        try {
            const productCode = document.querySelector('.js-personalized-pla-container').dataset.personalizedPlaCode;
            const container = document.querySelector('.js-personalized-pla-tagged-tab.tabs__content--active');
            const tag = container.dataset.personalizedPlaTag;
            const index = container.querySelectorAll('.js-personalized-pla-tagged-tab-cell').length;
            const list = container.querySelector('ul');

            const url = new URL('/content/personalized-pla/' + productCode + '/view-more/', window.location.origin);
            url.searchParams.set('selectedPlaTag', tag);
            url.searchParams.set('index', index);
            const res = await fetch(url.toString())
            const html = await res.text();
            list.insertAdjacentHTML('beforeend', html);
        } catch (err) {
            console.error(err);
        }
    });
}

window.initPDPJs = function(codeForInitJs) {
    var slideshow = $('#js-pdp-beauty-video-slideshow');
        slideshow.removeClass('slick-slideshow--js-trigger');
        slideshow.slick({
        arrows: false,
        dots: true,
        infinite: true,
        mobileFirst: true,
        autoplay: false,
        slidesToShow: 1,
        speed: 200,
        lazyLoad: 'progressive',
        touchThreshold: 20,
    });

    $('.js-horizontal-scroll').horizontalScroll();
    $('.js-chat-window').chatWindow();
    $('.js-color-dropdown').colorDropdown();
    $('.js-accordion').accordion();
    $('.js-modal').modal();
    $('.js-track-video').trackVideo();
    window.resetLazyLoad();
    $('.js-fav-button').toggleFavorite();
    window.addFavEvent(document.querySelector('.js-fav-button'));
    window.setupImageCarousel();
    window.setupStyliticsToggle($('ul.image-carousel li.image-carousel__item--stylitics a[data-stylitics-shop]'));
    $('.js-toggle-change').toggleChange();

    window.setupBisAndSo();

    $('#add-to-bag-form').submit(function (e) {
        e.preventDefault();
    });

    $('.js-tabs-size-guide').tabs({
        tab: '.tabs-size-guide__link',
        tabActive: 'tabs-size-guide__link--active',
        tabContentActive: 'sizeguide-tab-content--active'
    });

    $('select#size').on('invalid', function (e) {
        e.preventDefault();
    }).on('change', function() {
        const $this = $(this);
        const $oosButton = $('#oos-submit');
        const $selectedOption = $this.find('option:selected');
        const code = $selectedOption.data('code');
        if ($selectedOption.data('isSeparateProductCode')) {
            return; // this is handled as if it's a color change to fit in better with the AJAX retrieval
        }
        if (this.value) {
            var url = window.location.href;
            var r = new URL(url);
            r.searchParams.set('size', this.value);
            if (code !== undefined) {
                r.searchParams.set('product', code);
            }
            url = r.href;

            window.history.replaceState(null,document.title,url)
            $.ajax({
                type: 'POST',
                data: $.param({
                    url: url,
                    module: 'PDP Size Click',
                    action: 'Click',
                    details: this.value
                }),
                url: '/r/ajax/LogEngagement.jsp'
            });
            const otherColorsOosForSize = $selectedOption.data('colorsOos');
            $('.js-color-option').each((index, el) => {
                const $el = $(el);
                $el.text($el.data('defaultText'));
            });
            if (otherColorsOosForSize) {
                for (let i = 0; i < otherColorsOosForSize.length; i++) {
                    const otherColorCode = otherColorsOosForSize[i];
                    const $el = $(`#color-option-${otherColorCode}`);
                    if ($el && $el.data('oosText')) {
                        // https://stackoverflow.com/a/22706073
                        const elementForEncoding = document.createElement('p');
                        elementForEncoding.innerHTML = this.value;
                        $el.html(`${$el.data('oosText').replace('<size>', elementForEncoding.innerHTML)}`);
                    }
                }
            }

            const $fitPredictorRoot = $('.fp-root');
            if ($fitPredictorRoot.length) {
                const productData = ssp('get', 'product', $fitPredictorRoot.data('productId')) || {};
                productData.size = this.value;
                productData.price = $selectedOption.data('price');
                if ($selectedOption.data('regularPrice') !== $selectedOption.data('price')) {
                    productData.salePrice = $selectedOption.data('price');
                }
                productData.variantId = code + '_' + this.value;
                ssp('set', 'product', productData);
            }

            const oosNotifyRecommendationsModalHref = $selectedOption.data('notifyRecommendationsUrl');
            if (oosNotifyRecommendationsModalHref) {
                $.modal({
                    url: oosNotifyRecommendationsModalHref,
                    triggerOpen: true,
                    type: 'toast',
                    onComplete: function () {
                        $('.js-horizontal-scroll').horizontalScroll();
                        heartProduct('.js-similar-page-items', '.js-favorite-button');
                        $('.js-favorite-button').on('click', function() {
                            logEngagementWithDetails(window.location.href, 'oos similar recs', 'heart', $(this).data('pcode'));
                        });
                        $('.js-progressive-button').progressiveButton();
                        $('#js-bis-notify-me').notifyMe();
                        $('.js-add-to-bag').on('click', function() {
                            const $el = $(this);
                            addToBag($el.data('code'), $el.data('size'), null, { showJustAdded: false });
                            logEngagementWithDetails(window.location.href, 'oos similar recs', 'atc', $el.data('code'));
                        });
                    }
                });
                logEngagementWithDetails(window.location.href, 'oos similar recs', 'open recs', `${code}+${this.value}`);
            }
        }
        if ($oosButton.length > 0) {
            $('#product-info-form').removeClass('product__information--placeholder')
        }
    });

    if ($('#size-products').length > 0) {
        $('#size-products').on('invalid', function (e) {
            e.preventDefault();
        });
    }

    function getHTMLJSSaveId(value) {
      return value.toString().replace(/[\W_]+/g,'');
    }

    window.setUpProductHandlers();

    let $product = $('.product');

    $product.find('#product-swatches input').change(function(){
        var href = $(this).attr('data-href');
        if(href != ''){
            location.href = href;
        }
    });

    $product.find('#pdp-size-options input').change(function () {
        var el = $(this);
        var dataSize = $(obj).data('size');
        var oneLeft = el.data('oneLeft');
        var finalSale = el.data('finalSale');
        var isPreorder = el.data('preorder');
        var isOos = el.data('oos');
        var defectiveDisclaimer = el.data('defect-disclaimer');
        var inventoryDisclaimer = el.data('inventory-disclaimer');
        var sizeLabel = $('#size-selection-label');
        sizeLabel.removeClass('u-error');
        sizeLabel.html(el.data('size-label'));

        var showAfterPay = true;
        var showKlarna = true;
        if(isPreorder){
            sizeLabel.html(el.data('size-label') + ' ' + sizeLabel.data('preorder'));
            showAfterPay = false;
            showKlarna = false;
        }

        if(oneLeft){
            var oneLeftMsg = sizeLabel.data('one-left');
            if(isPreorder){
                sizeLabel.html(`${sizeLabel.html()} <span class='u-error'>${oneLeftMsg}</span>`);
            }else{
                sizeLabel.html(`${el.data('size-label')} <span class='u-error'>${oneLeftMsg}</span>`);
            }
        }

        if(isOos){
            showAfterPay = false;
            showKlarna = false;
        }

        if (document.getElementById('afterPayBox')) {
            if (showAfterPay) {
                $('#afterPayBox').show();
                if (dataSize !== '') {
                    const afterPayMessageBySize = $('#afterPayBox'+getHTMLJSSaveId(dataSize));
                    if (afterPayMessageBySize.length) {
                        $('.afterPayBoxMsg').hide();
                        afterPayMessageBySize.show();
                    }
                }
            } else
                $('#afterPayBox').hide();
        }
        if (document.getElementById('klarnaPayMsgOption')) {
            if (showKlarna) {
                $('#klarnaPayMsgOption').show();
                if (dataSize !== '') {
                    const klarnaMessageBySize = $('#installmentPlanMsg'+getHTMLJSSaveId(dataSize));
                    if (klarnaMessageBySize.length) {
                        $('.installmentPlanBoxMsg').hide();
                        klarnaMessageBySize.show();
                    }
                }
            } else {
                $('#klarnaPayMsgOption').hide();
            }
        }
    });


    var selectedInput = $product.find('#pdp-size-options input:checked');
    if(selectedInput.length > 0){
        selectedInput.trigger('change');
        selectedInput.trigger('click');
    }

    $('#size').change();

    $('.image-carousel').on('afterChange', function() {
        if($('.slick-active > .image-carousel__vid-container').length > 0) {
            $('.slick-active > .image-carousel__vid-container').addClass('image-carousel__vid-container--center');
            $('.product-badge').hide();
            $('.js-shop-the-look').hide();
        } else {
            $('.product-badge').show();
            $('.js-shop-the-look').show();
        }
    });

    var logEngagement = function (module, action, details) {
        $.ajax({
            type: 'POST',
            data: $.param({
                url: window.location.href,
                module: module,
                action: action,
                details: details
            }),
            url: '/r/ajax/LogEngagement.jsp'
        });
    };

    $('#js-pdp-video').lazy({
        afterLoad: function(element) {
            var src = element.attr('src');
            var muted = element.data('mute');
            if(muted === true) {
                element.attr('src', src + '&mute=1');
            }

        }
    });

    $('.js-track-size-fit-tab').click(function () {
        logEngagement('Size Fit Tab', 'Click');
    });

    $('.js-play-video-btn-update').on('click', function() {
        const video = $(this).find('video').get(0);
        video.play();
        $('.js-play-video-btn-update .video__play-icon').hide();
    });

    $('.js-play-video-btn').on('click', function() {
        $.modal({
            url: '/content/video/beauty/modal',
            data: $.param({
                videoId: $(this).data('videoId')
            }),
            video: true,
            triggerOpen: true,
        });
    });

    const pdpProps = window.rcProps.pdp || {};
    const productCodes = pdpProps.productCodes || [];
    if (productCodes && productCodes.length > 0) {
        $.ajax({
            type: 'GET',
            url: '/r/ajax/GetProductData.jsp',
            data: {
                product: productCodes,
                department: pdpProps.department,
            },
            success: function (rtn) {
                const data = parseRtn(rtn);
                const productData = data[pdpProps.code];
                const sizes = productData['inventory'];
                const otherCodesOutOfStockBySize = sizes.reduce(function (result, item) {
                    result[item['size']] = [];
                    return result;
                }, {});
                for (let i = 0; i < productCodes.length; i++) {
                    const colorwayCode = productCodes[i];
                    if (colorwayCode === pdpProps.code) {
                        continue;
                    }
                    if(data[colorwayCode]) {
                        const colorwaySizes = data[colorwayCode]['inventory'];
                        if (colorwaySizes) {
                            for (let j = 0; j < colorwaySizes.length; j++) {
                                const colorwaySize = colorwaySizes[j];
                                const oos = colorwaySize['quantity'] === 0;
                                if (oos) {
                                    const sizesOos = otherCodesOutOfStockBySize[colorwaySize['size']];
                                    if (sizesOos) {
                                        sizesOos.push(colorwayCode);
                                    }
                                }
                            }
                        }
                    }
                }
                for (let i = 0; i < sizes.length; i++) {
                    const size = sizes[i]['size'];
                    const optionInput = $(`#size-option-${sizes[i]['sizeForId']}`);
                    const otherCodesOos = otherCodesOutOfStockBySize[size];
                    if (optionInput) {
                        optionInput.data('colorsOos', otherCodesOos);
                    }
                }
                $('select#size').trigger('change'); // in case a size has already been selected (e.g., pre-selected size)
            }
        });
    }

    $('.js-shop-the-look').on('click', function(e) {
        e.preventDefault();
        if(typeof logEngagement === 'function')
            logEngagement(window.location.href, 'shop_the_look', 'click');
        $.modal({
            url: $(this).data('styliticsUrl'),
            type: 'toast',
            triggerOpen: true,
            onComplete: function() {
                $('.js-progressive-button').progressiveButton();
            },
            onLoad: function() {
                $('.modal__content')
                    .addClass('u-padding-r--none')
                    .find('.js-horizontal-scroll')
                    .horizontalScroll();
            }
        });
    });

    $('.js-view-review').click(function(e){
        e.preventDefault();
        var url = $(this).attr('href');
        $.modal({
            url: url,
            type: 'full',
            triggerOpen: true,
            onComplete: function () {
                $('[data-truncate]').truncate();
                $('.js-write-review').click(function (e) {
                    e.preventDefault();
                    var url = $(this).attr('href');
                    $.modal({
                        url: url,
                        type: 'full',
                        triggerOpen: true
                    });
                });
            }
        });
    });

    // Add to my list
    $('.js-my-list').on('click',function() {
        // check if already has a list
        const productCode = $(this).data('code');
        if (typeof logEngagement === 'function') {
            logEngagement('PDP My List', 'Click', 'Add to My List Clicked');
        }
        if (pdpProps.defaultMyLists) {
            const favListId = pdpProps.favoriteListId;
            if (pdpProps.defaultMyLists.indexOf(favListId) >= 0 &&
                $('.js-fav-button').hasClass(heartProduct.CLASS_NAMES.activated) === false) {
                addToFavorites(productCode, true, function () {
                    $('.js-fav-button').addClass(heartProduct.CLASS_NAMES.activated);
                    addToDefaultMyLists(productCode, true);
                });
            } else {
                addToDefaultMyLists(productCode, false);
            }
        } else {
            addToMyList(productCode);
        }
    });

    function addToDefaultMyLists(productCode, hearted) {
        const data = {
            code : productCode,
            hearted: hearted
        };

        $.modal({
            url: '/content/favorites/mylist/addProductToDefaultList',
            data: data,
            triggerOpen: true,
            type: 'toast-notification',
            addModifierClass: 'modal--toast-notification--bubble',
            closeButton: false,
            returnFocus: '.js-my-list',
            onComplete: function() {
                $('#manage-lists-link').on('click', function() {
                    addToMyList(productCode);
                });
            }
        });
    }

    function addToMyList(productCode) {
        const data = {
            code : productCode
        };
        $.modal({
            url: window.rcProps.hearts.addToMyListsModalHref + '?mobile=true',
            data: data,
            type: 'toast',
            triggerOpen: true,
            returnFocus: '.js-my-list',
            onComplete: function () {
                $('.js-toggle-change').toggleChange();
                $('.js-my-list-added').on('click', function() {
                    let lists = '';
                    $('.js-checkbox-saved-list').each(function (i, e) {
                        if ($(e).is(':checked')) {
                            lists += '&lists=' + $(e).data('id');
                        }
                    });
                    if (lists === '') {
                        if ($('.js-create-list-input').is(':visible') && $('#new-list').val().trim() == '') {
                            $('#creatNewListError').html('Please enter a list name');
                            $('.js-create-list-input').find('div.field').addClass('is-error');
                            $('#new-list').on('keypress', function () {
                                $('.js-create-list-input').find('div.field').removeClass('is-error');
                            });
                            return;
                        } else if($('.js-checkbox-saved-list').length === 0 && !$('.js-create-list-input').is(':visible')){
                            $('#list-not-created-error').removeClass('u-hide');
                            $('.js-checkbox-saved-list').on('click', function () {
                                $('#list-not-created-error').addClass('u-hide');
                            });
                            return;
                        } else if($('.js-checkbox-saved-list').length > 0 && !$('.js-create-list-input').is(':visible')) {
                            $('#no-list-selected-error').removeClass('u-hide');
                            $('.js-checkbox-saved-list').on('click', function () {
                                $('#no-list-selected-error').addClass('u-hide');
                            });
                            return;
                        }
                    }
                    let addToMyListUrl = window.rcProps.hearts.addProductToListHref;
                    if (pdpProps.defaultMyLists) {
                        addToMyListUrl = '/content/favorites/mylist/addRemoveProductToMyLists';
                    }
                    $.ajax({
                        url: addToMyListUrl + '?product=' + productCode +'&newListName=' + $('#new-list').val() + lists ,
                        type: 'POST',
                        success: function (listsData) {
                            $('.js-create-list-input').find('div.field').removeClass('is-error');
                            if (pdpProps.defaultMyLists) {
                                if (typeof logEngagement === 'function') {
                                    logEngagement('PDP My List', 'Product added', 'Product added to list');
                                }
                                const favListId = pdpProps.favoriteListId;
                                let listIds = '';
                                let removedListIds = '';
                                if (listsData && typeof listsData === 'object') {
                                    if (listsData.addedList) {
                                        listIds = listsData.addedList;
                                    }

                                    if (listsData.removedList) {
                                        removedListIds = listsData.removedList;
                                    }
                                }
                                if (listIds.trim() === '' && removedListIds.trim() === '') {
                                    $.modal.close();
                                    return;
                                }
                                $.modal({
                                    url: '/content/favorites/mylist/productAddedConfirmation?listIds=' + listIds + '&removedListIds=' + removedListIds,
                                    triggerOpen: true,
                                    type: 'notification',
                                    returnFocus: '.js-my-list',
                                });
                                if (lists.indexOf(favListId) < 0 && $('.js-fav-button').hasClass(heartProduct.CLASS_NAMES.activated)) {
                                    addToFavorites(productCode, false, function () {
                                        $('.js-fav-button').removeClass(heartProduct.CLASS_NAMES.activated);
                                    });
                                } else if (lists.indexOf(favListId) >= 0 && !$('.js-fav-button').hasClass(heartProduct.CLASS_NAMES.activated)) {
                                    addToFavorites(productCode, true, function () {
                                        $('.js-fav-button').addClass(heartProduct.CLASS_NAMES.activated);
                                    });
                                }
                            } else {
                                if (listsData.errorMessage) {
                                    $('#creatNewListError').html(listsData.errorMessage);
                                    $('.js-create-list-input').find('div.field').addClass('is-error');
                                } else {
                                    if (typeof logEngagement === 'function') {
                                        logEngagement('PDP My List', 'Product added', 'Product added to list');
                                    }
                                    $.modal({
                                        url: window.rcProps.hearts.addToMyListConfirmModalHref + '?product=' + productCode + '&d=' + rcProps.department + '&newListName=' + $('#new-list').val() + lists,
                                        type: 'toast',
                                        triggerOpen: true,
                                    })
                                }
                            }
                        }
                    });
                })
            }
        });
    }
    $('.js-alt-view-video').on('click', function() {
        const module = `Mobile PDP ${$(this).data('videoLocation')}`;
        logEngagement(
          module,
          'Video Click',
          $(this).data('videoId')
        );
    });

    // attach engagement tracking listeners for FP
    let $fitPredictorRoot = $('.fp-root');
    $fitPredictorRoot.on('click', '.fp-element', function() {
        logEngagement('Fit Predictor', 'Click');
    }).on('click', '.fp-button-edit', function() {
        logEngagement('Fit Predictor', 'Edit');
    }).on('click', '.fp-button-add-more', function() {
        logEngagement('Fit Predictor', 'Add More');
    });

    const $deliveryUrgencyContainer = $('.js-delivery-urgency-container');
    if ($deliveryUrgencyContainer.length) {
        $.get('/content/product/mobile/delivery-urgency-messaging?code=' + (codeForInitJs || window.rcProps.pdp.code),
          function(markup) {
            $deliveryUrgencyContainer.html(markup);
        });
    }

    $.get(window.rcProps.fittingRoomShopModuleHref, $.param({code: window.rcProps.pdp.code })).done((markup) => {
        $('#fitting-room-shop-module').html(markup);
    });

    window.bindSizeGuideEvent();
    revieveMakeupAdvisor();

    if (codeForInitJs) {
        renderPdpSocialProof(codeForInitJs);
    } else {
        window.insertStylisticsImagesByAjax(window.rcProps.pdp.code).then(() => {
            renderPdpSocialProof(window.rcProps.pdp.code);
            if (window.rcProps.revieveEventEnabled) {
                revieveTryOn();
            } else {
                $(window).on('revieveScriptLoaded', function () {
                    revieveTryOn();
                });
            }
        });
    }
}

$(function() {
    initPDPJs();

    function isSizeSelected(){
        if(!$('select#size').is(':visible')){
            return true; //one size
        }
        var size = $('select#size').val();
        if(size == ''){
            $('select#size').prop('required','required');
            return false;
        }else{
            $('select#size').removeProp('required');
            return true;
        }
    }

    window.addToBag = function(btn, size){
        if(typeof size ==='undefined' || size === 'undefined') {
            size = getPdpSize();
            if (size == '' || size === 'unavailable') {
                sizeNotSelectedBeforeAddingToBag = true;
                return;
            }
        }
        const code = getPdpCode(btn);
        console.assert(code, 'Code is invalid when clicking Add To Bag CTA');
        addToBag(code, size, function() {
            const $fitPredictorRoot = $('.fp-root');
            if ($fitPredictorRoot.length) {
                ssp('track', 'addVariantToCart', {
                    productId: $fitPredictorRoot.data('productId'),
                    quantity: 1,
                    variantId: code + '_' + size
                });
            }
        })
    }

    window.addBuyNowProduct = function(btn) {
        var size = getPdpSize();
        if(size == ''){
            return;
        }
        const code = getPdpCode(btn)
        console.assert(code, 'Code is invalid when clicking Buy Now CTA');
        addBuyNowProduct(code, size, getFittingRoomItemSize(), btn);
    }

    function getFittingRoomItemSize() {
        var size = '';
        if($('#fittingRoomSize').length > 0) {
            size = $('#fittingRoomSize').find(':selected').val();
        }
        return size;


    }

    function getPdpSize(){
        var size = '';
        if($('#pdp-size-options').length > 0){
            if($('#pdp-size-options input:checked').length == 0){
                $('#size-selection-label').html($('#size-selection-label').data('select-error-text'));
                $('#size-selection-label').addClass('u-error');
                $('#size-selection-label').focus();
                return '';
            }
            size = $('#pdp-size-options input:checked').val();
        } else if ($('#size-products').length > 0) { // beauty volume options are products displayed as sizes
            size = $('#size-products option:selected').val();
            if (size == '') {
                $('#size-products').prop('required','required');
            } else {
                $('#size-products').removeProp('required');
            }
        }else{
            size = $('select#size').val();
            if(!isSizeSelected()){
                return '';
            }
        }
        return size;
    }

    function getPdpCode(btn) {
        return $('select#size option:selected').data('code') || $(btn).data('code');
    }

    if (window.rcProps.pdp.preloadColorMarkup) {
        preloadColorMarkup($('.product').find('.product__color select option, .js-size-option'));
    }
    if(window.location.href.indexOf('AddToList=true') > -1){
        var newURL = location.href.replace('&AddToList=true', '');
        window.history.pushState('object', document.title, newURL);
        if($('a.js-my-list').length){
            $('a.js-my-list').click();
        }
    }

    const $influencerBanner = $('#influencer-banner');
    if ($influencerBanner.length) {
        $.get(window.rcProps.influencerShareBannerHref, $.param({code: window.rcProps.pdp.code}))
          .done((markup) => $influencerBanner.html(markup));
    }

    const $styleExpertBanner = $('#style-expert-banner');
    if ($styleExpertBanner.length) {
        $.get(window.rcProps.styleExpertBannerHref).done((markup) => $styleExpertBanner.html(markup));
    }

    $.post(window.rcProps.checkFavoriteHref, $.param({code: window.rcProps.pdp.code}))
      .done((result) => {
          let activeHeartClass = window.rcProps && window.rcProps.favoriteActiveClass
            || 'favorite-button--active';

          $('#detailsMarkup .js-fav-button').toggleClass(activeHeartClass, result.isFavorite)
      });

    if (window.rcProps && window.rcProps.pdp && window.rcProps.pdp.showMiniTopNav) {
        window.triggerAccordion = (element) => {
            const activeItem = $('#product-info .accordion__item--active');
            const elementHref = element.id;

            if (activeItem.length > 0) {
                const activeContent = activeItem.find('.accordion__content');
                activeItem.removeClass('accordion__item--active');
                activeContent.css({ height: '', display: '' });
            }

            // hard-coded values come from UX-18319
            const topOffset = 45;
            let scrollPosition = $(`${elementHref}`).offset().top - topOffset;

            if (elementHref === '#product-details'
                || elementHref === '#product-size'
                || elementHref === '#product-reviews'
                || elementHref === '#product-ingredients'
                || elementHref === '#similarItemsMarkup') {
                $(elementHref).click();
                $('html, body').animate({
                    scrollTop: scrollPosition
                }, 500);
                logEngagementWithDetails(window.location.href, 'Mini Top Nav', elementHref, window.rcProps.pdp.code);
            }

            if (activeItem.length && activeItem.height() < 500 && (scrollPosition - activeItem.height()) > 1000) {
                scrollPosition -= activeItem.height() - topOffset;
            }
        }
    }
    revieveAddToBag();
});

document.addEventListener('zeligWidgetLoaded', function() {
    $('.js-zelig-try-on').removeClass('u-hide');
});

document.addEventListener('WidgetModalOpen', function() {
    logEngagement(window.location.href, 'Zelig', 'PDP widget clicks');
});

document.addEventListener('hue-add-to-cart', (e) => {
    const code = e.detail.variantId;
    let size;
    if ($('#size-products').length) {
        size = $(`#size-products option[data-code="${code}"]`).val();
    } else {
        size = $('select#size').val();
    }

    addToBag(code, size, function() {
        const $fitPredictorRoot = $('.fp-root');
        if ($fitPredictorRoot.length) {
            ssp('track', 'addVariantToCart', {
                productId: $fitPredictorRoot.data('productId'),
                quantity: 1,
                variantId: code + '_' + size
            });
        }
    });
    $('.hue-cart-menu-header__close').click();
});


document.addEventListener('hue-integration', () => {
    const { detail } = e;
    if (detail.type === 'video-popup-open') {
        logEngagementWithDetails(window.location.href, 'hue', 'open modal', window.rcProps.pdp.code);
    }
});



// WEBPACK FOOTER //
// ./src/scripts/entry-points/pdp/index.js